<section
  class="animate-in fade-in slide-in-from-bottom-2 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
  <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
    <h2 class="title text-[18px] font-bold">{{ isArabic() ? "إعدادات الصنف" : "Product Settings" }}</h2>
  </div>

  <div>
    <h3 class="textTabsColor mb-3 text-sm font-bold">
      {{ isArabic() ? "خاضع لضريبة القيمة المضافة" : "Subject to VAT" }}
    </h3>
    <div class="borderDivColor bgSoftGrayColor flex w-64 items-center gap-3 rounded-lg border px-4 py-3">
      <app-toggle-button [isActive]="config().isVATApplied" (submit)="onToggleClick()" />
      <span class="text-gray text-sm font-medium">{{ isArabic() ? "ضريبة القيمة المضافة" : "VAT" }}</span>
    </div>
  </div>
</section>

@if (pendingVat() !== null) {
  <app-confirmation-dialog
    [layout]="'start'"
    [title]="dialog().title"
    [description]="dialog().description"
    [confirmContent]="dialog().confirmContent"
    [cancelContent]="dialog().cancelContent"
    [error]="errorSave()"
    (onSubmit)="confirm()"
    (onCancel)="closeConfirmation()" />
}
